import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import Select, { components } from 'react-select';
import { setMessage } from '../../../store/redux/slices/alertMessageSlice';
import countryCodes from '../../../utils/countrycodes.json';
import CloseIcon from '@mui/icons-material/Close';
const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};

export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  @media only screen and ${device.tablet} {
    overflow-x: hidden;
    overflow-y: scroll;
    height: 100%;
  }
`;

const Modal = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  width: 600px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  @media only screen and ${device.tablet} {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 15px;
    padding-bottom: 20px;
    width: 285px;
    padding-top: 30px;
  }
`;
const InputRow = styled.div`
  display: flex;
  gap: 10px;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 10px;

  @media only screen and ${device.tablet} {
    flex-direction: column;
    align-items: center;
    margin-bottom: unset;
  }
`;

const Input = styled.input`
  flex: 1;
  width: ${(props) => (props?.name === 'phone' ? '180px' : '200px')};
  color: #121212;

  padding: 12px 16px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(
    90.01deg,
    rgba(138, 186, 185, 0.6) 0.01%,
    rgba(176, 208, 208, 0.3) 99.99%
  );
  font-size: 16px;
  &::placeholder {
    color: #121212;
  }
  @media only screen and ${device.tablet} {
    width: ${(props) => (props?.name === 'phone' ? '195px' : '302px')};
  }
`;

const SingleInput = styled(Input)`
  width: 545px;
  margin-bottom: 30px;
  color: #121212;
  @media only screen and ${device.tablet} {
    width: 302px;
  }
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
const CloseButton = styled.button`
  display: block;
  margin: 0 10px;
  padding: 12px 32px;
  font-size: 18px;
  border: none;
  border-radius: 10px;
  color: #2a2929;
  cursor: pointer;
  font-weight: bold;
  transition: background 0.3s ease;
  background: linear-gradient(
    90.01deg,
    rgba(138, 186, 185, 0.6) 0.01%,
    rgba(176, 208, 208, 0.3) 99.99%
  );
  &:hover {
    cursor: pointer;
  }
`;
const Button = styled.button`
  display: block;
  margin: 0 10px;
  padding: 12px 32px;
  font-size: 18px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(90deg, #063257, #006867);
  color: white;
  cursor: pointer;
  font-weight: bold;
  transition: background 0.3s ease;

  &:hover {
    cursor: pointer;
    background: linear-gradient(93.98deg, #092f6b 0.31%, #3a865e 99.69%);
  }
`;
const Title = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 36px;
      
  text-align: center;
  vertical-align: middle;
  background: linear-gradient(90deg, #063257 0%, #006867 100%);
  color: transparent;
  background-clip: text;
  @media only screen and ${device.tablet} {
    font-size: 24px;
    width: 294px;
  }
`;
const Divider = styled.div`
  border: 2px solid #0c3f89;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 30px;
`;
const TitleDescription = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 18px;
      
  text-align: center;
  vertical-align: middle;
  color: #12121299;
  margin-top: 20px;
  @media only screen and ${device.tablet} {
    margin-top: 10px;
    width: 296px;
    font-size: 16px;
  }
`;
const NumberContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const SelectContainer = styled.div`
  width: 60px;
  z-index: 0;
  . css-hlgwow {
    display: flex;
  }
  @media only screen and ${device.tablet} {
    width: 95px;
  }
`;

const BookDemoPopup = ({ isOpen, setIsOpen }) => {
  const customSingleValue = ({ data }) => <div>{data.code}</div>;
  // const CustomInput = (props) => {
  //   if (!props.selectProps.menuIsOpen) return null;
  //   return <components.Input {...props} />;
  // };
  const [selected, setSelected] = useState('');
  const customOption = (props) => {
    const { data, innerRef, innerProps, isFocused } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          padding: '10px 12px',
          backgroundColor: isFocused ? '#f0f0f0' : '#fff',
          color: '#121212',
          cursor: 'pointer',
        }}
      >
        {data.code} - {data.name}
      </div>
    );
  };
  const options = countryCodes.map((country) => ({
    value: country.code,
    label: `${country.code} - ${country.name}`,
    code: country.code,
    name: country.name,
  }));
  const customStyles = {
    control: (base, { isFocused }) => ({
      ...base,
      padding: '0 4px',
      borderRadius: '10px',
      background: 'linear-gradient(90deg, #d5e5e5, #dce8e8)',
      fontSize: '16px',
      width: window?.innerWidth < 768 ? '95px' : '60px',
      height: '42px',
      boxShadow: 'none',
      cursor: 'pointer',
      '.css-hlgwow': {
        display: 'flex',
        padding: 'unset',
      },
    }),
    singleValue: (base) => ({
      ...base,
      fontWeight: '500',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '4px',
    }),
    menu: (base) => ({
      ...base,
      borderRadius: '10px',
      overflow: 'auto',
      maxHeight: '200px',
      zIndex: 100,
    }),
    option: (base, { isFocused }) => ({
      ...base,
      backgroundColor: isFocused ? '#f0f0f0' : '#fff',
      color: '#121212',
      cursor: 'pointer',
    }),
  };
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    country: '',
    companySize: '',
    isMarketingAgency: '',
    notes: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const fullPhoneNumber = `${formData.country}${formData.phone}`; // Concatenate code + phone
    const submissionData = {
      ...formData,
      phone: fullPhoneNumber, // Override phone with full number
    };

    const scriptURL =
      'https://script.google.com/macros/s/AKfycbzy04U8mkrN12UNyGqgIiRo-n0MtuJE1tN3wtv7zq0TVgYXeh6-J0q6Y5RFVfYakxYL/exec';

    try {
      await fetch(scriptURL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        mode: 'no-cors',
        body: JSON.stringify(submissionData),
      });

      dispatch(
        setMessage({
          message: 'Submitted the request successfully!!',
          type: 'Success',
        })
      );
      setIsOpen(false);

      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        company: '',
        country: '',
        companySize: '',
        isMarketingAgency: '',
        notes: '',
      });
    } catch (error) {
      alert(JSON.stringify(error));
    }
  };

  return (
    isOpen && (
      <Overlay onClick={() => setIsOpen(false)}>
        <Modal onClick={(e) => e.stopPropagation()}>
          <Title>Get Your Brand’s Emotional GPS Today</Title>
          <TitleDescription>
            Book a demo with our product specialists to discover how BrandAstra
             helps you decode what your customers really feel.
          </TitleDescription>
          <Divider />
          <form onSubmit={handleSubmit}>
            <InputRow>
              <Input
                placeholder='First Name'
                type='text'
                name='firstName'
                value={formData.firstName}
                onChange={handleChange}
                required
                pattern='[A-Za-z]+'
                title='Please enter a valid input.'
              />
              <Input
                placeholder='Last Name'
                type='text'
                name='lastName'
                value={formData.lastName}
                onChange={handleChange}
                required
                pattern='[A-Za-z]+'
                title='Please enter a valid input.'
              />
            </InputRow>
            <InputRow>
              <Input
                placeholder='Work Email'
                type='email'
                name='email'
                value={formData.email}
                onChange={handleChange}
                required
              />
              <NumberContainer>
                <SelectContainer
                  style={{ width: window?.innerWidth < 768 ? '95px' : '60px' }}
                >
                  <Select
                    name='country'
                    options={options}
                    value={options.find(
                      (opt) => opt.value === formData.country
                    )}
                    onChange={(selected) => {
                      handleChange({
                        target: { name: 'country', value: selected.value },
                      });
                      setSelected(selected.value);
                    }}
                    placeholder={' '}
                    styles={customStyles}
                    components={{
                      SingleValue: customSingleValue,
                      Option: customOption,
                      ...(selected?.length > 1 && {
                        DropdownIndicator: '',
                      }),
                    }}
                  />
                </SelectContainer>
                <Input
                  placeholder='Phone Number'
                  style={{ zIndex: '9999' }}
                  type='tel'
                  name='phone'
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  pattern='[0-9]{10,14}'
                  title='Please enter a valid input.'
                />
              </NumberContainer>
            </InputRow>
            <SingleInput
              placeholder='Organization Name'
              type='text'
              name='company'
              value={formData.company}
              onChange={handleChange}
              required
              pattern='^[A-Za-z@&]+(\s[A-Za-z@&]+)*$'
              title='Please enter a valid input.'
            />
            <ButtonWrapper>
              <Button type='submit'>Book a Demo</Button>
              <CloseButton onClick={() => setIsOpen(false)}>Close</CloseButton>
            </ButtonWrapper>
          </form>
        </Modal>
      </Overlay>
    )
  );
};

export default BookDemoPopup;
